import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';

const Sidebar = () => {
  const location = useLocation();
  
  const handleLogout = () => {
    localStorage.clear();
    window.location.href = '/login';
  };

  return (
    <StyledSidebar>
      <LogoContainer>
        <Logo src="/logo.png" alt="Xtreme Logo" />
      </LogoContainer>
      
      <NavLinks>
        <StyledLink to="/dashboard" $active={location.pathname === '/dashboard'}>
          <DashboardIcon />
          <span>Dashboard</span>
        </StyledLink>
        <StyledLink to="/profile" $active={location.pathname === '/profile'}>
          <PersonIcon />
          <span>Profile</span>
        </StyledLink>
      </NavLinks>
      
      <LogoutButton onClick={handleLogout}>
        <LogoutIcon />
        <span>Logout</span>
      </LogoutButton>
    </StyledSidebar>
  );
};

const StyledSidebar = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 250px;
  height: 100vh;
  background: #2c3e50;
  color: white;
  padding: 2rem;
  display: flex;
  flex-direction: column;
`;

const LogoContainer = styled.div`
  margin-bottom: 3rem;
`;

const Logo = styled.img`
  width: 100%;
  height: auto;
`;

const NavLinks = styled.nav`
  flex: 1;
`;

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  padding: 0.8rem;
  border-radius: 5px;
  transition: background 0.2s;
  background: ${props => props.$active ? '#34495e' : 'transparent'};

  &:hover {
    background: #34495e;
  }

  svg {
    margin-right: 1rem;
  }

  span {
    font-size: 1.1rem;
  }
`;

const LogoutButton = styled.button`
  background: #e74c3c;
  color: white;
  border: none;
  padding: 0.8rem;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.2s;
  display: flex;
  align-items: center;

  &:hover {
    background: #c0392b;
  }

  svg {
    margin-right: 0.5rem;
  }
`;

export default Sidebar;
